import React from 'react';
import { Box, Flex, IconButton } from '@chakra-ui/react';
import { UilCheck, UilTrashAlt } from '@iconscout/react-unicons';
import { useDispatch } from 'react-redux';
import { getAuthHeader } from '../../../utils/auth-token';

const UploadImageUI = ({
	imageList,
	onImageUpload,
	onImageRemoveAll,
	onImageUpdate,
	isDragging,
	dragProps,
	images = [],
	updateRedux,
	uploadImage,
	setUploadImage,
	isLoading,
}) => {
	const [isUploading, setIsUploading] = React.useState(false);
	const dispatch = useDispatch();
	const saveToS3 = () => {
		const img = uploadImage[0];
		setIsUploading(true);
		const formData = new FormData();
		formData.append('img', img.file);
		const queryString = new URLSearchParams({ lastModified: img.file.lastModified }).toString();
		fetch(`${process.env.REACT_APP_COMPILER_URL}/api/s3/upload-image?${queryString}`, {
			method: 'POST',
			body: formData,
			headers: getAuthHeader(),
		})
			.then((res) => res.json())
			.then(({ url }) => {
				const newImgs = [...(images || []), url];
				setIsUploading(false);
				dispatch(updateRedux(newImgs));
				setUploadImage([]);
			});
	};

	return (
		<Box>
			<Box
				_hover={{ background: '#fffee6', cursor: 'pointer' }}
				bg={isDragging ? '#fffee6' : 'white'}
				{...placeholderProps}
				onClick={() => (imageList.length ? onImageUpdate(0) : onImageUpload())}
			>
				<Box {...dragProps} {...placeholderDotted} {...textStyle}>
					Clique ou arraste uma imagem
				</Box>
			</Box>

			{imageList.map((image, index) => (
				<Box mt={2} key={`upload-image-ui-${index}`}>
					<Box p={2}>
						<img src={image['data_url']} alt="" style={{ maxWidth: '100%', maxHeight: '200px' }} />
					</Box>
					<Flex gap={'8px'}>
						<IconButton
							isLoading={isUploading || isLoading}
							size={'sm'}
							icon={<UilCheck />}
							onClick={saveToS3}
							_hover={y300}
							_active={y400}
							_focus={y400}
						/>
						<IconButton
							isLoading={isUploading || isLoading}
							size={'sm'}
							icon={<UilTrashAlt />}
							onClick={onImageRemoveAll}
							_hover={r300}
							_active={r400}
							_focus={r400}
						/>
					</Flex>
				</Box>
			))}
		</Box>
	);
};

export default UploadImageUI;

function cleanFileName(fileName) {
	//removendo diacriticos
	return fileName
		.normalize('NFD')
		.replace(/[\u0300-\u036f]/g, '')
		.replace(/[^.a-zA-Z0-9]/g, '-');
}

const placeholderProps = {
	padding: '0px',
	d: 'flex',
	transition: '.3s',
};

const placeholderDotted = {
	border: 'dashed 2px #ecc94b',
	borderRadius: '3px',
	w: '100%',
	verticalAlign: 'middle',
	d: 'flex',
	p: 3,
};

const textStyle = {
	color: '#ecc94b',
	fontWeight: 700,
	fontSize: '18px',
	alignSelf: 'center',
	margin: '0 auto',
	justifyContent: 'center',
};
const y300 = { bg: 'yellow.300', borderColor: 'yellow.300' };
const y400 = { bg: 'yellow.400', borderColor: 'yellow.400' };
const r300 = { bg: 'red.300', borderColor: 'red.300' };
const r400 = { bg: 'red.400', borderColor: 'red.400' };
